import { GEPStateSnapshot } from './GoalEditorPanel/GEPState/GEPStateSnapshot';

export function PrepareForDbAdd(GEPState: GEPStateSnapshot) {
	const currentState = GEPState.currentState as Partial<
		typeof GEPState.currentState
	>;

	delete currentState.id;
	delete currentState.datapoints;
	delete currentState.daysleft;
}
